

import { Component, Vue, Prop } from 'vue-property-decorator';
import { IPaymentCardListItem } from "./interface";

@Component
export default class IBPaymentCardList extends Vue {

	@Prop({ type: Array, default: () => [] })
	readonly list!: IPaymentCardListItem[]

	isLastItem(index: number): boolean {
		return index + 1 === this.list?.length;
	}

	@Prop(Boolean)
	readonly isHistoryType!: boolean

}

